module.exports = __webpack_public_path__ + "static/homunculus-7d02f2da64c2fc2a387f372c426e5789.jpg";